import { cn } from '@/lib/cn'

/** §7.1 — los cuatro estados. El cliente nunca ve `borrador`. */
export type EstadoPublicacion = 'borrador' | 'para_revisar' | 'cambios' | 'aprobada'

const ETIQUETA: Record<EstadoPublicacion, { larga: string; corta: string }> = {
  borrador: { larga: 'Borrador', corta: 'Borrador' },
  para_revisar: { larga: 'Para revisar', corta: 'Revisar' },
  cambios: { larga: 'Cambios en curso', corta: 'Cambios' },
  aprobada: { larga: 'Aprobada', corta: 'Aprobada' },
}

/**
 * Para RASTRO, "Para revisar" confunde: la pieza no la revisa el equipo, espera
 * al cliente. Mismo estado y color, otra etiqueta (revisión OO, 21/09/2026).
 */
const ETIQUETA_RASTRO: Partial<typeof ETIQUETA> = {
  para_revisar: { larga: 'Esperando revisión', corta: 'Esperando' },
}

const ESTILO: Record<EstadoPublicacion, string> = {
  borrador:
    'bg-borrador text-borrador-tinta border border-dashed border-borrador-tinta/60',
  para_revisar: 'bg-revisar text-revisar-tinta',
  cambios: 'bg-cambios text-cambios-tinta',
  aprobada: 'bg-aprobada text-aprobada-tinta',
}

interface ChipEstadoProps {
  estado: EstadoPublicacion
  /** `corta` es la abreviatura del calendario (§7.1). */
  forma?: 'larga' | 'corta'
  /** La etiqueta cambia según quién mira: ver `ETIQUETA_RASTRO`. */
  paraRastro?: boolean | undefined
  className?: string | undefined
}

/**
 * Chip de estado: color **y** texto, siempre (§2.2).
 */
export function ChipEstado({
  estado,
  forma = 'larga',
  paraRastro = false,
  className,
}: ChipEstadoProps) {
  return (
    <span
      data-estado={estado}
      className={cn(
        'inline-flex items-center rounded-full px-3 py-1 text-[13px] font-medium leading-5',
        ESTILO[estado],
        className,
      )}
    >
      {((paraRastro ? ETIQUETA_RASTRO[estado] : undefined) ?? ETIQUETA[estado])[forma]}
    </span>
  )
}
